import React, { Fragment, useState, useEffect } from "react";
import { Col, Card, CardHeader, Row } from "reactstrap";
import CountUp from "react-countup";
import { H3, H6, Image, LI, UL } from "../../../../../AbstractElements";
import {
  BOD,
  Contact,
  ContactUsNumber,
  DDMMYY,
  Designer,
  Email,
  Follower,
  Following,
  LocationDetails,
  MarekjecnoMailId,
  MarkJecno,
  Location,
} from "../../../../../Constant";
import { GeneralMedicalRecordList } from "../../../../../apiController";

const GeneralSummary = ({ data }) => {
  const [url, setUrl] = useState("");
  const [record, setRecord] = useState([]);

  const readUrl = (event) => {
    if (event.target.files.length === 0) return;
    var mimeType = event.target.files[0].type;

    if (mimeType.match(/image\/*/) == null) {
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      setUrl(reader.result);
    };
  };

  // GeneralMedicalRecordList

  const fetchRecord = async () => {
    const response = await GeneralMedicalRecordList();
    if (response.status === true) {
      const filteredId = response.data.filter(
        (item) => item.patient_id === data.id
      );
      setRecord(filteredId);
    }
  };

  useEffect(() => {
    fetchRecord();
  }, []);

  console.log(record);
  return (
    <Fragment>
      <Col sm="12">
        <Card className="hovercard text-center">
          <CardHeader className="border-0 font-secondary">
            <H3>General Medical Record</H3>
          </CardHeader>
          {/* <CardHeader className='cardheader'></CardHeader> */}
          {record.slice(-1).map((row, ind) => (
            <div className="info" key={ind}>
              <Row className="step3 " data-intro="This is the your details">
                <Col sm="6" lg="4" className="order-sm-1 order-xl-0">
                  <div className="ttl-info">
                    <div>
                      <H6>{"SUFFERED"}</H6>
                    </div>
                    <div className="desc mt-2 ">
                      {" "}
                      <span className="d-flex justify-content-center gap-1 font-warning">
                        <span>
                          {row.astjma === "yes" ? <p>Asthuma</p> : ""}
                        </span>
                        <span>
                          {row.epilepsy === "yes" ? <p>Epilepsy</p> : ""}
                        </span>
                        <span>
                          {row.diabets === "yes" ? <p>Diabetes</p> : ""}
                        </span>
                        <span>
                          {row.heart_problem === "yes" ? (
                            <p>Heart Problem </p>
                          ) : (
                            ""
                          )}
                        </span>
                        <span>
                          {row.blood_disease === "yes" ? (
                            <p>Blood Disease</p>
                          ) : (
                            ""
                          )}
                        </span>
                        <span>
                          {row.jaundice === "yes" ? <p>Jaundice</p> : ""}
                        </span>
                        <span>{row.others ? <p>{row.others}</p> : ""}</span>
                      </span>
                    </div>
                  </div>
                </Col>

                <Col sm="6" lg="4" className="order-sm-1 order-xl-0">
                  <Row>
                    {data.gender === "Female" && (
                      <Col md="6">
                        <div className="ttl-info">
                          <H6>
                            <i className="fa me-2"></i> {"PREGNANT"}
                          </H6>
                          {row.due_date ? (
                            <span>Due Date:{row.due_date}</span>
                          ) : (
                            "No"
                          )}
                        </div>
                      </Col>
                    )}
                    <Col md="6">
                      <div className="ttl-info ttl-sm-mb-0">
                        <H6>
                          <i className="fa me-2"></i>
                          {"HABITS"}
                        </H6>
                        <span className="d-flex justify-content-center gap-1 font-warning">
                          <span>
                            {row.alcohol == "yes" ? <p>Alcohol</p> : ""}
                          </span>
                          <span>{row.paan == "yes" ? <p>Paan</p> : ""}</span>
                          <span>
                            {row.tobacco == "yes" ? <p>Tobacco</p> : ""}
                          </span>
                        </span>
                      </div>
                    </Col>
                  </Row>
                </Col>

                <Col sm="6" lg="4" className="order-sm-2 order-xl-2">
                  <Row>
                    <Col md="6">
                      <div className="ttl-info  ttl-xs-mt">
                        <H6>
                          <i className="fa me-2"></i>
                          {"ALLERGIC"}
                        </H6>
                        <span className="d-flex justify-content-center gap-1 font-warning">
                          <span>
                            {row.aspirin == "yes" ? <p>Aspirin</p> : ""}
                          </span>
                          <span>{row.sulfa == "yes" ? <p>Sulfa </p> : ""}</span>
                          <span>
                            {row.local_aneshthetic == "yes" ? (
                              <p>LocalAneshthetic</p>
                            ) : (
                              ""
                            )}
                          </span>
                          <span>
                            {row.ibuprofen == "yes" ? <p>Ibuprofen</p> : ""}
                          </span>
                          <span>
                            {row.mention_others == null ? (
                              ""
                            ) : (
                              <p>{row.mention_others}</p>
                            )}
                          </span>
                        </span>
                      </div>
                    </Col>
                    <Col md="6">
                      <div className="ttl-info ttl-sm-mb-0">
                        <H6>
                          <i className="fa-arrow me-2"></i>
                          {"MEDICATION"}
                        </H6>
                        <span className="d-flex justify-content-center gap-1 font-warning">
                          {row.medication?row.medication: "-" }
                        </span>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          ))}
        </Card>
      </Col>
    </Fragment>
  );
};

export default GeneralSummary;
